import type { IconSvgProps } from '../Icon.types';

export const Minus = ({ width, height }: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 9 1"
    fill="currentColor"
  >
    <path d="M9 0.375C9 0.474456 8.96049 0.569839 8.89017 0.640165C8.81984 0.710491 8.72446 0.75 8.625 0.75H0.375C0.275544 0.75 0.180161 0.710491 0.109835 0.640165C0.0395089 0.569839 0 0.474456 0 0.375C0 0.275544 0.0395089 0.180161 0.109835 0.109835C0.180161 0.0395089 0.275544 0 0.375 0H8.625C8.72446 0 8.81984 0.0395089 8.89017 0.109835C8.96049 0.180161 9 0.275544 9 0.375Z" />
  </svg>
);
